module.exports = __webpack_public_path__ + "img/jobs.6c21e078.png";